<template>
  <div>
    <listing :class="{ multiple }" ref="downloads-list"></listing>
  </div>
</template>

<script>

import Listing from '@/components/transfers/Listing.vue';
import { files as api } from '@/api';
import { mapGetters, mapState, mapMutations } from 'vuex';

export default {
  name: 'files',
  components: {
    Listing
  },
  computed: {
    ...mapGetters([
      'selectedCount',
      'isListing',
      'isEditor',
      'isFiles'
    ]),
    ...mapState([
      'req',
      'user',
      'reload',
      'multiple',
      'loading',
      'isDelete'
    ]),
    isPreview () {
      return false;
    }
  },
  data: function () {
    return {
      error: null
    };
  },
  created () {
    let thisComponent = this;
    let JavaEventListenerClass = Module.ActionListener.extend('ActionListener', {
      onActionProgress: function(action)
      {
          if (action.type != Module.ActionType.DOWNLOAD.value
            && action.type != Module.ActionType.DOWNLOAD_ZIP.value) {
            return;
          }

          //thisComponent.$refs["downloads-list"].$refs[action.tag][0].setProgress(90);
          if (thisComponent.req.items)
          {
            for (let i = 0; i < thisComponent.req.items.length; i++) {
              if (thisComponent.req.items[i]['tag'] == action.tag) {
                  let value = action.size ? action.completed * 100 / action.size : 0;
                  let index = i;
                  thisComponent.$store.commit('updateTransferProgress', { index , value });
                  return;
              }
            }
            thisComponent.fetchData();
          }
      },
      onActionFinish: function(action)
      {
          if (action.type != Module.ActionType.DOWNLOAD.value
            && action.type != Module.ActionType.DOWNLOAD_ZIP.value) {
            return;
          }
          thisComponent.fetchData();
      }
    });

    //var interfaceObject = Module.ActionListener.implement(this);
    this.interfaceObject = new JavaEventListenerClass();
    ibb.addActionListener(this.interfaceObject);
    this.fetchData();
  },
  watch: {
    '$route': 'fetchData',
    'reload': function () {
      this.fetchData();
    }
  },
  mounted () {
    window.addEventListener('keydown', this.keyEvent);
    window.addEventListener('scroll', this.scroll);
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.keyEvent);
    window.removeEventListener('scroll', this.scroll);
    ibb.removeActionListener(this.interfaceObject);
  },
  destroyed () {
    this.$store.commit('updateRequest', {});
  },
  methods: {
    ...mapMutations([ 'setLoading' ]),
    async fetchData () {

      // Reset view information.
      this.$store.commit('setReload', false);
      this.$store.commit('resetSelected');
      this.$store.commit('multiple', false);
      this.$store.commit('closeHovers');

      // Set loading to true and reset the error.
      this.setLoading(true);
      this.error = null;

      try {
        const res = await api.getDownloads();

        /*if (clean(res.path) !== clean(`/${this.$route.params.pathMatch}`)) {
          return
        }*/

        this.$store.commit('updateRequest', res);
        //document.title = res.name
      } catch (e) {
        this.error = e;
      } finally {
        this.setLoading(false);
      }
    },
    keyEvent (event) {
      // Esc!
      if (event.keyCode === 27) {
        this.$store.commit('closeHovers');

        // If we're on a listing, unselect all
        // files and folders.
        if (this.isListing) {
          this.$store.commit('resetSelected');
        }
      }

      // Del!
      if (event.keyCode === 46) {
        if (!this.isFiles ||
          this.loading ||
          (this.isListing && this.selectedCount === 0) || this.isDelete) return;

        this.$store.commit('showHover', 'delete');
      }

      // F1!
      if (event.keyCode === 112) {
        event.preventDefault();
        this.$store.commit('showHover', 'help');
      }
    },
    scroll () {
      if (this.req.kind !== 'listing' || this.$store.state.user.viewMode === 'mosaic') return;

      let top = 112 - window.scrollY;

      if (top < 64) {
        top = 64;
      }

      document.querySelector('#listing.list .item.header').style.top = top + 'px';
    },
    openSidebar () {
      this.$store.commit('showHover', 'sidebar');
    },
    openSearch () {
      this.$store.commit('showHover', 'search');
    }
  }
};
</script>
